import React from "react";
import logoCollapsed from "../../../assets/logo-collapsed.png";

const SidebarSkeleton = () => {
  return (
    <div
      className="d-flex flex-column rounded bg-custom overflow-auto"
      style={{ height: "100%", width: "80px" }}
    >
      <div className="navbar-brand mt-2 mt-lg-0 mb-4 p-2">
        <a href="www.emalpha.com">
          <img src={logoCollapsed} height="50" alt="Emalpha Logo" />
        </a>
      </div>

      {/* Button Placeholders */}
      <div
        className="shimmer my-2"
        style={{ height: "30px", width: "60%" }}
      ></div>

      {/* Menu Item Placeholders */}
      {Array.from({ length: 5 }).map((_, index) => (
        <div
          key={index}
          className="shimmer my-1"
          style={{ height: "20px", width: "70%" }}
        ></div>
      ))}

      {/* Logout Button Placeholder */}
      <div
        className="shimmer my-3"
        style={{ height: "30px", width: "60%" }}
      ></div>
    </div>
  );
};

export default SidebarSkeleton;
